import helper from "../helper";
// import user from "../store/modules/user";

let getSurveyUrl = helper.getSurveyUrlWithParameters

export default {
    getSurveyUrl,
    getByRecievedUrlData:
      /**
       * Получает URL на основе полученных данных
       * @param {Object} url - Объект с данными URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL
       */
      (url, gets = null) => getSurveyUrl(
        url.basename,
        url.action,
        url.params,
        gets
    ),
    SURVEYING: {
        SURVEY: {
            LIST:
              /**
               * Получает URL для списка опросов
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка опросов
               */
                (gets = null) => getSurveyUrl(
                    'surveys|surveying_survey|survey-list',
                    "list",
                    gets
                ),
            DETAIL:
              /**
               * Получает URL для детальной информации об опросе
               * @param {number} id - Идентификатор опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения деталей опроса
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|surveying_survey|survey-detail',
                    "retrieve",
                    {id: id},
                    gets
                ),
        },
        ATTEMPT: {
            LIST:
              /**
               * Получает URL для списка попыток прохождения
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения списка попыток
               */
                (gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|attempt-list',
                    "list",
                    gets
                ),
            CREATE:
              /**
               * Получает URL для создания новой попытки прохождения
               * @param {string} key - Ключ опроса
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для создания попытки
               */
                (key, gets = null) => getSurveyUrl(
                  'attempts|surveying_attempt|attempt-list',
                  "create",
                    {key: key},
                  gets
            ),
            CHECK:
              /**
               * Получает URL для проверки попытки прохождения
               * @param {number} id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для проверки попытки
               */
                (id, gets = null) => getSurveyUrl(
                    'surveys|surveying_survey|survey-attempt-check',
                    "attempt_check",
                    {id: id},
                    gets
                ),
            END:
              /**
               * Получает URL для завершения попытки прохождения
               * @param {number} id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для завершения попытки
               */
                (id, gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|attempt-attempt-end',
                    "attempt_end",
                    {id: id},
                    gets
                ),
            STAGE_LIST:
              /**
               * Получает URL для списка этапов попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения этапов попытки
               */
                (attempt_id, gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|stage-list',
                    "list",
                    {attempt_id: attempt_id},
                    gets
                ),
            FIELD_LIST:
              /**
               * Получает URL для полей этапа попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения полей этапа
               */
                (attempt_id, stage_id, gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|stage_field-list',
                    "list",
                    {
                        attempt_id: attempt_id,
                        stage_id: stage_id
                    },
                    gets
                ),
            STAGE_SAVE:
              /**
               * Получает URL для сохранения ответов этапа
               * @param {number} attempt_id - Идентификатор попытки
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для сохранения ответов этапа
               */
                (attempt_id, stage_id, gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|stage-stage-answers-save',
                    "stage_answers_save",
                    {
                        attempt_id: attempt_id,
                        id: stage_id
                    },
                    gets
                ),
            ANSWER_LIST:
              /**
               * Получает URL для списка ответов попытки
               * @param {number} attempt_id - Идентификатор попытки
               * @param {number} stage_id - Идентификатор этапа
               * @param {Object} gets - Query-параметры
               * @returns {string} URL для получения ответов попытки
               */
                (attempt_id, stage_id, gets = null) => getSurveyUrl(
                    'attempts|surveying_attempt|attempt_answer-list',
                    "list",
                    {
                        attempt_id: attempt_id,
                        stage_id: stage_id
                    },
                    gets
                ),
        }
    },
}
